import loader from '../moduleLoader';

class Notification {
    constructor(container) {
        this.container = container;
        this.close = this.close.bind(this);
    }
    init() {
        this.container.querySelector('.notification__close').addEventListener('click', this.close);
    }
    close(e) {
        this.container.classList.add('notification--removing');
        // setTimeout(() => {
            this.container.remove();
        // }, 400);
    }
}

loader.add('Notification', Notification);

export default Notification;